/* src/components/Icon.svelte generated by Svelte v3.55.0 */
import {
	SvelteComponentDev,
	add_location,
	append_hydration_dev,
	attr_dev,
	children,
	claim_svg_element,
	detach_dev,
	dispatch_dev,
	init,
	insert_hydration_dev,
	noop,
	safe_not_equal,
	svg_element,
	validate_slots,
	xlink_attr
} from "../../web_modules/svelte/internal.js";

import { getContext } from '../../web_modules/svelte.js';
const file = "src/components/Icon.svelte";

function create_fragment(ctx) {
	let svg;
	let use;
	let use_xlink_href_value;

	const block = {
		c: function create() {
			svg = svg_element("svg");
			use = svg_element("use");
			this.h();
		},
		l: function claim(nodes) {
			svg = claim_svg_element(nodes, "svg", { class: true, "aria-hidden": true });
			var svg_nodes = children(svg);
			use = claim_svg_element(svg_nodes, "use", { "xlink:href": true });
			children(use).forEach(detach_dev);
			svg_nodes.forEach(detach_dev);
			this.h();
		},
		h: function hydrate() {
			xlink_attr(use, "xlink:href", use_xlink_href_value = "" + (/*spriteUrl*/ ctx[2] + "#" + /*name*/ ctx[1]));
			add_location(use, file, 32, 2, 1010);
			attr_dev(svg, "class", /*classes*/ ctx[0]);
			attr_dev(svg, "aria-hidden", "true");
			add_location(svg, file, 31, 0, 965);
		},
		m: function mount(target, anchor) {
			insert_hydration_dev(target, svg, anchor);
			append_hydration_dev(svg, use);
		},
		p: function update(ctx, [dirty]) {
			if (dirty & /*spriteUrl, name*/ 6 && use_xlink_href_value !== (use_xlink_href_value = "" + (/*spriteUrl*/ ctx[2] + "#" + /*name*/ ctx[1]))) {
				xlink_attr(use, "xlink:href", use_xlink_href_value);
			}

			if (dirty & /*classes*/ 1) {
				attr_dev(svg, "class", /*classes*/ ctx[0]);
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(svg);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let spriteUrl;
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('Icon', slots, []);

	const types = {
		action: '@salesforce-ux/design-system/assets/icons/action-sprite/svg/symbols.svg',
		custom: '@salesforce-ux/design-system/assets/icons/custom-sprite/svg/symbols.svg',
		doctype: '@salesforce-ux/design-system/assets/icons/doctype-sprite/svg/symbols.svg',
		standard: '@salesforce-ux/design-system/assets/icons/standard-sprite/svg/symbols.svg',
		utility: '@salesforce-ux/design-system/assets/icons/utility-sprite/svg/symbols.svg'
	};

	let { type = 'utility' } = $$props;
	let { name } = $$props;
	let { classes = '' } = $$props;
	let baseUrl = '';

	getContext('baseUrl').subscribe(value => {
		$$invalidate(4, baseUrl = value);
	});

	$$self.$$.on_mount.push(function () {
		if (name === undefined && !('name' in $$props || $$self.$$.bound[$$self.$$.props['name']])) {
			console.warn("<Icon> was created without expected prop 'name'");
		}
	});

	const writable_props = ['type', 'name', 'classes'];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<Icon> was created with unknown prop '${key}'`);
	});

	$$self.$$set = $$props => {
		if ('type' in $$props) $$invalidate(3, type = $$props.type);
		if ('name' in $$props) $$invalidate(1, name = $$props.name);
		if ('classes' in $$props) $$invalidate(0, classes = $$props.classes);
	};

	$$self.$capture_state = () => ({
		getContext,
		types,
		type,
		name,
		classes,
		baseUrl,
		spriteUrl
	});

	$$self.$inject_state = $$props => {
		if ('type' in $$props) $$invalidate(3, type = $$props.type);
		if ('name' in $$props) $$invalidate(1, name = $$props.name);
		if ('classes' in $$props) $$invalidate(0, classes = $$props.classes);
		if ('baseUrl' in $$props) $$invalidate(4, baseUrl = $$props.baseUrl);
		if ('spriteUrl' in $$props) $$invalidate(2, spriteUrl = $$props.spriteUrl);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*baseUrl, type*/ 24) {
			$: $$invalidate(2, spriteUrl = `${baseUrl}/${types[type]}`);
		}

		if ($$self.$$.dirty & /*classes*/ 1) {
			$: {
				const classNames = new Set(classes.split(' '));
				classNames.add('slds-icon');

				if (classNames.has('slds-button__icon')) {
					classNames.delete('slds-icon');
				}

				$$invalidate(0, classes = [...classNames].join(' ').trim());
			}
		}
	};

	return [classes, name, spriteUrl, type, baseUrl];
}

class Icon extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, { type: 3, name: 1, classes: 0 });

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "Icon",
			options,
			id: create_fragment.name
		});
	}

	get type() {
		throw new Error("<Icon>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set type(value) {
		throw new Error("<Icon>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get name() {
		throw new Error("<Icon>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set name(value) {
		throw new Error("<Icon>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get classes() {
		throw new Error("<Icon>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set classes(value) {
		throw new Error("<Icon>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default Icon;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
//# sourceMappingURL=Icon.js.map
